module.exports = __webpack_public_path__ + "img/symbol_10_x250.1545be9c.png";